import moment from 'moment';
import { RateFastUpdateFormType } from './RateFastUpdateFormType';

export const createInitialValues = (): RateFastUpdateFormType => ({
  expirationDate: moment(),
  porcentage: ''
});
